import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class ArticleAd extends Component {
  render() {
    const ads = this.props.ads;

    if(!ads.page_body_wide_ad_image) {
      return false;
    }

    if (ads.article_sidebar_ad_image === 'http://api.sniffers.co.nz/wp-content/uploads/') {
      // Issue with the image upload (empty?)
      return false;
    }

    return (
      <a href={ads.article_sidebar_ad_link} target="_blank" className={css(styles.container)}>
        <img src={ads.article_sidebar_ad_image} />
      </a>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    backgroundColor: 'transparent',
    width: 280,
    height: 300,
  },
})



// WEBPACK FOOTER //
// ./src/components/ArticleAd/index.js